
namespace RioERP.Orders {

    @Serenity.Decorators.registerClass()
    export class OrderShippingGrid extends Serenity.EntityGrid<OrderShippingRow, any> {
        protected getColumnsKey() { return OrderShippingColumns.columnsKey; }
        protected getDialogType() { return OrderShippingDialog; }
        protected getIdProperty() { return OrderShippingRow.idProperty; }
        protected getInsertPermission() { return OrderShippingRow.insertPermission; }
        protected getLocalTextPrefix() { return OrderShippingRow.localTextPrefix; }
        protected getService() { return OrderShippingService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}